// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  detail: yup.array().required().of(
    yup.object().shape({
      preview_id: yup.number().required(),
      group_coa_id: yup.number().required(),
      status: yup.number().required(),
      coa_cheque: yup.string().label("CHQ").required(),
      coa_code: yup.string().label("ACCOUNT").required(),
      coa_name: yup.string().label("NAME").required(),
      coa_level: yup.number().label("LEVEL").required(),
      header_level: yup.string().label("HEADER").required(),
      location_id: yup.string().label("LOCATION").defined(),
      account_type_id: yup.string().label("ACCOUNT TYPE").when('header_level', {
        is: (val: string) => val === "1",
        then: (schema) => schema.defined(),
        otherwise: (schema) => schema.required()
      })
    })
  )
})

export type FormType = yup.InferType<typeof validationSchema>